/* eslint-disable */
export default {
  logging: 'Kirjataan lokiin...',
  logCall: 'Kirjaa puhelu lokiin',
  editLog: 'Muokkaa lokia',
  select: 'Valitse vastaava tallenne',
  OnHold: 'Pidossa',
  Ringing: 'Soitetaan',
  CallConnected: 'Puhelu yhdistetty',
  unknownUser: 'Tuntematon käyttäjä',
  unknownNumber: 'Nimetön',
  unavailable: 'Ei käytettävissä',
  viewDetails: 'Näytä tiedot',
  addEntity: 'Luo uusi',
  addLog: 'Loki',
  text: 'Tekstiviesti',
  call: 'Soita',
  addContact: 'Lisää yhteystieto',
  missedCall: 'Vastaamaton',
  inboundCall: 'Saapuva',
  outboundCall: 'Lähtevät',
  from: 'Läh.:',
  to: 'Vastaanottaja',
  hangup: 'Lopeta puhelu',
  accept: 'Vastaa',
  toVoicemail: 'Vastaajaan',
  anonymous: 'Nimetön',
  mergeToConference: 'Yhdistä käynnissä olevaan puheluun',
  hold: 'Pito',
  unhold: 'Poista pidosta',
  transfer: 'Siirrä',
  reject: 'Hylkää',
  switchCall: 'Siirrä puhelu tähän sovellukseen',
  callSwitch: 'Puhelun siirto',
  comfirmContext:
    'Sinulla on meneillään puhelu henkilön {displayName} kanssa. Haluatko jatkaa puhelua tällä laitteella?',
  comfirmCancelButton: 'Peruuta',
  comfirmOKButton: 'Vaihda',
  ignore: 'Ohita',
  holdAndAnswer: 'Aseta pitoon ja vastaa',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
